module.exports = __webpack_public_path__ + "img/icon-rated.35b20cc3.svg";